<template>
  <v-card flat>
    <v-card-text class="pt-6">
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col
              v-for="(report, i) in loadingReports && page === 1
                ? 8
                : reportsData"
              :key="`report-${i}`"
              cols="12"
              sm="6"
              lg="4"
            >
              <v-skeleton-loader
                width="100%"
                :loading="loadingReports"
                transition="scale-transition"
                type="card"
              >
                <v-card outlined>
                  <router-link
                    :to="{
                      name: 'report-detail',
                      params: { id: report.reportId }
                    }"
                  >
                    <v-img height="200" :src="report.coverImage" />
                  </router-link>
                  <v-card-title>
                    <router-link
                      :to="{
                        name: 'report-detail',
                        params: { id: report.reportId }
                      }"
                    >
                      <span
                        class="grey--text text-body-1 font-weight-bold text-md-h6"
                      >
                        {{ report.reportTitle | title }}
                      </span>
                    </router-link>
                  </v-card-title>
                  <v-card-subtitle>
                    {{ report.reportDatetime | datetime }}
                  </v-card-subtitle>
                </v-card>
              </v-skeleton-loader>
            </v-col>
            <v-col
              v-if="
                paginationReports.totalPage > 1 &&
                  page < paginationReports.totalPage
              "
              cols="12"
              class="text-center mt-8 mb-12"
            >
              <v-btn
                :loading="loadingReports"
                color="light-green"
                class="text-capitalize"
                @click="
                  page += 1;
                  getReportsHandler();
                "
                dark
              >
                Muat lebih banyak
              </v-btn>
            </v-col>
            <v-col cols="12" v-show="!loadingReports && reportsData.length < 1">
              <div class="text-center text--secondary">
                <v-icon
                  style="font-size: 60px; margin-top: 1.5em"
                  color="light-green"
                >
                  mdi-close-circle-outline
                </v-icon>
                <p class="headline font-weight-bold mt-2 mb-1">Data kosong</p>
                <p>Data yang Anda cari tidak ada disini</p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import report from '@/mixins/report';
export default {
  mixins: [report],
  data() {
    return {
      reportsData: [],
      page: 1
    };
  },
  created() {
    this.getReportsHandler();
  },
  methods: {
    async getReportsHandler() {
      const filters = [
        {
          type: 'string',
          field: 'account_id',
          value: this.$route.params.id,
          comparison: '<>'
        }
      ];
      const payload = {
        filters,
        page: this.page
      };
      const reportsData = await this.getReports(payload);
      this.reportsData.push(...reportsData);
    }
  }
};
</script>
